import React from 'react'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import CommonDatepicker from 'components/common/Datepicker/Datepicker'
import {
  DefaultWrapper,
  DefaultWeekDay,
  DefaultMonth,
  DefaultCell
} from 'components/common/Datepicker/components'

const Wrapper = styled(DefaultWrapper)`
  margin: 0 auto 25px;
`

const Month = styled(DefaultMonth)`
  ${Mixin.responsive('font-size', '24px', '20px')}
  ${Mixin.responsive('line-height', '34px', '30px')}
`

const WeekDay = styled(DefaultWeekDay)`
  ${Mixin.responsive('padding', '15px 0', '8px 0')}
  ${Mixin.responsive('font-size', '12px', '10px')}
`

const Cell = styled(DefaultCell)`
  line-height: 22px;
  ${Mixin.responsive('padding', '14px 10px', '9px')}
  ${Mixin.responsive('font-size', '14px', '10px')}
`

const Datepicker = (props) =>
  <CommonDatepicker { ...props } components={{ Wrapper, Month, WeekDay, Cell }} />

export default Datepicker
